import { render, staticRenderFns } from "./emscrapList.vue?vue&type=template&id=048aaf6b&scoped=true"
import script from "./emscrapList.vue?vue&type=script&lang=js"
export * from "./emscrapList.vue?vue&type=script&lang=js"
import style0 from "./emscrapList.vue?vue&type=style&index=0&id=048aaf6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048aaf6b",
  null
  
)

export default component.exports